import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { OkrMetric } from "server/models"
import { hasAccess } from "client/utils"
import { PRM_ACCOUNT_SETTINGS, StoreType, addModal } from "client/store"
import {
    TableColumn,
    Link,
    UserIcon,
} from "client/components"

import EditOkrMetric from "./edit"

const Columns = () => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editAccess = hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
        },
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "100px",
            formatter: (metric: OkrMetric) => (editAccess
                ? (
                    <Link
                        href="/#"
                        onClick={() => dispatch(addModal({
                            key: "editOkrMetric",
                            content: <EditOkrMetric metricId={metric.id} />,
                        }))}
                    >
                        {metric.name}
                    </Link>
                )
                : metric.name
            ),
        },
        {
            field: "symbol",
            header: lang.symbol,
            cellMinWidth: "100px",
        },
        {
            field: "displayAfter",
            header: lang.displayAfterNumber,
            cellMinWidth: "100px",
            formatter: (metric: OkrMetric) => (metric.displayAfter ? lang.yes : lang.no),
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellMinWidth: "150px",
            formatter: (metric: OkrMetric) => {
                const user = userList[metric.creator]
                return <UserIcon user={user} size="sm" />
            },
        },
    ]

    if (editAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
